/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The enum class of EventStatus
 */

export enum EventStatus {

    /**
     * 正常状态的事件。
     */
    NORMAL = 'normal',

    /**
     * 被阻止上报的事件
     * @type {string}
     */
    BLOCKED = 'blocked',

    /**
     * 上报失败的事件。
     * @type {string}
     */
    FAILED = 'failed',

    /**
     * 上报超时的事件。
     * @type {string}
     */
    TIMEOUT = 'timeout'
}
